var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex overflow-auto"},[_c('div',{class:[
      'huntingWords-theme-default position-relative mx-auto  m-3',
      _vm.showGrid && 'border',
    ],style:({
      'grid-template-rows': `repeat(${_vm.rows}, 2.5rem)`,
      'grid-template-columns': `repeat(${_vm.columns}, 2.5rem)`,
    })},[_vm._l((_vm.table),function(cell){return _c('div',{key:`${cell.positionx}-${cell.positiony}`,class:[
        'd-flex justify-content-center font-weight-bold align-items-center text-center',
        _vm.showGrid && 'border-cell',
      ],attrs:{"data-positiony":cell.positiony,"data-positionx":cell.positionx}},[_vm._v("\n      "+_vm._s(cell.text)+"\n    ")])}),(_vm.showWordPositions)?_vm._l((_vm.highlightedWords),function(highlight,i){return _c('div',{key:'highlight-' + i,class:[
          _vm.highlightMode === 'border'
            ? 'highlight-border'
            : `highlight-${highlight.direction} highlight-border-color`,
        ],style:(_vm.getHighlightStyle(highlight))})}):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }